import React from "react";
import {useStyles} from "./LogoOverlayStyles.css";
import logoImage from "../../../../../../assets/judged_overlay_logo.png";
import PlayButton from "../../scoreboard-content/buttons/PlayButton";

const LogoOverlay = ({ onButtonClick, isLoading }) => {
    const classes = useStyles();

    return (
        <div className={classes.logoContainer}>
            <img className={classes.logoImageBox} src={logoImage}></img>
            <PlayButton
                className={classes.playButton}
                onButtonClick={onButtonClick}
                isLoading={isLoading}
            />
        </div>
    );
};

export default LogoOverlay;
